import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWriteDotAsComponent } from './simple-icons-write-dot-as.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWriteDotAsComponent ],
    exports:      [ SimpleIconsWriteDotAsComponent ],
    bootstrap:    []
})
export class SimpleIconsWriteDotAsModule {}
